export type Preset = "this-month" | "last-month" | "this-year" | "last-year" | "last-12-months";

export const PRESETS: { id: Preset; label: string }[] = [
  { id: "this-month", label: "This month" },
  { id: "last-month", label: "Last month" },
  { id: "this-year", label: "This year" },
  { id: "last-year", label: "Last year" },
  { id: "last-12-months", label: "Last 12 months" },
];

// Lagos is UTC+1 with no DST.
export const lagosToday = (now: number = Date.now()): string => new Date(now + 3600_000).toISOString().slice(0, 10);

const pad = (n: number) => String(n).padStart(2, "0");
const iso = (y: number, m: number, d: number) => `${y}-${pad(m)}-${pad(d)}`;
// Day 0 of the next month is the last day of this one (m is 1-based).
const lastDay = (y: number, m: number) => new Date(Date.UTC(y, m, 0)).getUTCDate();

export function presetRange(p: Preset, today: string): { from: string; to: string } {
  const y = Number(today.slice(0, 4));
  const m = Number(today.slice(5, 7));
  switch (p) {
    case "this-month":
      return { from: iso(y, m, 1), to: today };
    case "last-month": {
      const ly = m === 1 ? y - 1 : y;
      const lm = m === 1 ? 12 : m - 1;
      return { from: iso(ly, lm, 1), to: iso(ly, lm, lastDay(ly, lm)) };
    }
    case "this-year":
      return { from: iso(y, 1, 1), to: today };
    case "last-year":
      return { from: iso(y - 1, 1, 1), to: iso(y - 1, 12, 31) };
    case "last-12-months": {
      const idx = y * 12 + (m - 1) - 11;
      return { from: iso(Math.floor(idx / 12), (idx % 12) + 1, 1), to: today };
    }
  }
}
